<template>
	<v-app
		v-bind="$attrs"
		v-on="$listeners">
		<slot/>
	</v-app>
</template>

<script>
export default {
	name: 'KApp',
	inheritAttrs: false,
	props: {
	}
}
</script>